import React from 'react'

function Card() {
  return (
    <div>
  
    </div>
  )
}

export default Card